module.exports = __webpack_public_path__ + "img/mh.2ecc381c.svg";